"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var PRODUCT_URL = /^\/products\/[^/]+/;
var VARIANT_URL = /^\/products:variants\/[^/]+/;
var CATEGORY_URL = /^\/categories\/[^/]+/;
var ITEM_URL = /^\/[^/]+\/[^/]+\/items\/[^/]+/;
var _default = exports["default"] = {
  asset_url: function asset_url(input) {
    if (typeof input !== 'string') {
      return;
    }
    return '/assets/' + input.replace(/^\//, '');
  },
  img_url: function img_url(src, query) {
    if (!src || typeof src === 'string') {
      return src;
    }
    var resourceUrl = src.toString();
    if (!resourceUrl) {
      return;
    }

    // Product
    if (PRODUCT_URL.test(resourceUrl)) {
      return getImageFileUrl(src.images, query);
    }

    // Variant
    if (VARIANT_URL.test(resourceUrl)) {
      return src.parent().then(function (product) {
        if (product.images) {
          for (var i = 0; i < product.images.length; i++) {
            if (product.images[i].id === src.image_id) {
              return getImageFileUrl(product.images, query);
            }
          }
        }
      });
    }

    // Category
    if (CATEGORY_URL.test(resourceUrl)) {
      // TODO: category will soon have single image instead of array
      if (src.image) {
        return getImageFileUrl(src.image, query);
      }
      return getImageFileUrl(src.images, query);
    }

    // Order/cart item
    if (ITEM_URL.test(resourceUrl)) {
      if (!src.product) {
        return;
      }
      return src.product().then(function (_product) {
        return getImageFileUrl(src.images, query);
      });
    }

    // Edge cases
    if (src.images) {
      return getImageFileUrl(src.images, query);
    }
    if (src.parent && src.parent.images) {
      return getImageFileUrl(src.parent.images, query);
    }
    if (src.product && src.product.images) {
      return getImageFileUrl(src.product.images, query);
    }
    if (src.file && src.file.url) {
      return getImageFileUrl(src, query);
    }
    if (src.url) {
      return getImageFileUrl(src, query);
    }
  }
}; // Safely extract first image.file.url from source object or array
function getImageFileUrl(image, query) {
  if (!image) {
    return;
  }
  if (image instanceof Array) {
    image = image[0] && image[0].file && image[0].file.url;
  } else {
    image = image.file && image.file.url || image.url;
  }
  if (image) {
    query = typeof query === 'string' ? query.replace(/\?/, '') : '';
    image = "" + image + (query ? "?" + query : '');
  }
  return image;
}